import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForm = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto').style('cursor', 'default')

      this.canvasForm
      .append('image')
      .attr('xlink:href', this.HOST + '/icon/Logo/JGS_Logo.svg')
      .attr('x', 20).attr('y', 15).attr('width', 230)

      this.canvasForm
      .append('text')
      .attr('x', 20).attr('y', 87)
      .attr('font-size', this.title.main.tSize).attr('fill', this.title.main.tColor)
      .text(this.title.main.visible == 'Y' ? this.title.main.name : '')

      this.canvasForm
      .append('text')
      .attr('x', 20).attr('y', 100)
      .attr('font-size', this.title.sub.tSize).attr('fill', this.title.sub.tColor)
      .text(this.title.sub.visible == 'Y' ? this.title.sub.name : '')

      this.draw_Radial() // -----> draw_Radial.js
      this.tbl_Handover()
      

      this.gmx_header_Depth2(this.canvasForm, this.system, 25, 'mx', 10, 'SYS')   
      this.gmx_header_Depth2(this.canvasForm, this.subsys, 25, 'mx', 10, 'SUBSYS')       

      
      this.tbl_System(99)

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }

    },


    draw_Scrollbar() {
    
      if(this.scroll.content.height < 455) return

      let bar = this.scroll.bar
      let scroll = this.canvasContents
      .append('g')
      .attr('id', `CANVAS_SCROLL_${this.localId}`)
      .attr('transform', `translate(${this.system.width}, 0)`)

      scroll
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', bar.width).attr('height', this.scroll.viewbox.height)
      .attr('fill', '#E0E0DF').attr('opacity', .3)

      console.log(this.scroll.viewbox.height , this.scroll.content.height)

      scroll
      .append('rect')
      .attr('id', `SCROLL_BAR_${this.localId}`)
      .attr('x', 0).attr('y', 0)
      .attr('width', bar.width).attr('height', this.scroll.bar.size)
      .attr('fill', bar.color).attr('opacity', bar.opacity)
      .call(
        d3.drag()
        .on('drag', (event) => this.dragging(event))
      )
    },

    dragging(event) {
      let bar = this.scroll.bar
      let viewbox = this.scroll.viewbox

      bar.y = bar.y + event.dy

      if(bar.y < 0) bar.y = 0
      if((bar.y + bar.size) > viewbox.height) bar.y = bar.space

      d3.select(`#${this.localId}`).select(`#SCROLL_BAR_${this.localId}`).attr('y', bar.y)

      let bar_ratio = bar.y / bar.space
      let y_ = viewbox.space * bar_ratio
      d3.select(`#${this.localId}`).select(`#CONTENTS_${this.localId}`).attr('transform', `translate(${0}, ${-y_ + 0})`)

    },

  }
}